import { AxiosRequestConfig } from "axios";

import { RequestInterceptor } from "@/types/http/request-interceptor";

import { jwtService } from "@/jwt";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * JWT interceptor.
 * It adds Authorization Bearer header with token value.
 */
export const jwtInterceptor: RequestInterceptor = {
  onFulfilled(
    value: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> | AxiosRequestConfig {
    if (jwtService.isTokenValid && !jwtService.isTokenExpired) {
      value.headers["authorization"] = `bearer ${jwtService.tokenString}`;
    }
    return value;
  }
};
